// Sort dropdown — ID-y zgodne z WooCommerce `?orderby=` query param.
// Klik w opcję przekierowuje do URL z nowym ?orderby; etap 9 (FacetWP) zamieni
// na real AJAX bez full reload.

const SORT_OPTIONS = [
  ['menu_order', 'Polecane'],
  ['date', 'Najnowsze'],
  ['price', 'Cena: rosnąco'],
  ['price-desc', 'Cena: malejąco'],
  ['title', 'Alfabetycznie A-Z'],
  ['title-desc', 'Alfabetycznie Z-A'],
];

function initSortDropdown() {
  const roots = document.querySelectorAll('[data-sort-root]');
  if (!roots.length) return;

  function closeAll() {
    document.querySelectorAll('[data-sort-menu]').forEach((m) => m.remove());
    document.querySelectorAll('[data-sort-caret]').forEach((c) => { c.style.transform = ''; });
  }

  roots.forEach((root) => {
    const toggle = root.querySelector('[data-sort-toggle]');
    const label = root.querySelector('[data-sort-label]');
    const caret = root.querySelector('[data-sort-caret]');
    if (!toggle || !label) return;
    toggle.addEventListener('click', (e) => {
      e.stopPropagation();
      const existing = root.querySelector('[data-sort-menu]');
      closeAll();
      if (existing) return;
      const menu = document.createElement('div');
      menu.setAttribute('data-sort-menu', '');
      menu.className = 'absolute left-0 top-full mt-2 w-[230px] bg-white border hairline rounded-[6px] shadow-[0_18px_40px_-20px_rgba(0,0,0,0.25)] z-50 overflow-hidden';
      const current = label.textContent.trim();
      menu.innerHTML = SORT_OPTIONS.map(([id, name]) => {
        const active = current === name;
        return `<button type="button" data-sort-pick="${id}" class="w-full text-left px-5 py-2.5 text-[13px] hover:bg-black/[.04] transition-colors ${active ? 'font-semibold bg-black/[.03]' : ''}">${name}</button>`;
      }).join('');
      root.appendChild(menu);
      if (caret) caret.style.transform = 'rotate(180deg)';
      menu.querySelectorAll('[data-sort-pick]').forEach((b) => {
        b.addEventListener('click', (ev) => {
          ev.stopPropagation();
          const id = b.getAttribute('data-sort-pick');
          const pick = SORT_OPTIONS.find((o) => o[0] === id);
          if (pick) label.textContent = pick[1];
          closeAll();
          try {
            const url = new URL(window.location.href);
            if (id === 'menu_order') {
              url.searchParams.delete('orderby');
            } else {
              url.searchParams.set('orderby', id);
            }
            url.searchParams.delete('paged');
            window.location.href = url.toString();
          } catch (_err) {
            // Brak window.location (np. SSR) — no-op.
          }
        });
      });
    });
  });

  document.addEventListener('click', (e) => {
    const inMenu = e.target.closest && e.target.closest('[data-sort-menu]');
    const inToggle = e.target.closest && e.target.closest('[data-sort-toggle]');
    if (!inMenu && !inToggle) closeAll();
  });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeAll(); });
}

if (typeof document !== 'undefined') {
  if (document.readyState !== 'loading') initSortDropdown();
  else document.addEventListener('DOMContentLoaded', initSortDropdown);
}
